// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__WNRWR","content":"default_content__tNkOH","controls":"default_controls__JGPVj"};